// extracted by mini-css-extract-plugin
export default {"root":"ProgressBar_root__18ISq","bg":"ProgressBar_bg__34NQ6","bar":"ProgressBar_bar__U-c8n","label":"ProgressBar_label__3qvH-","current":"ProgressBar_current__3SwH8"};